<template>
  <div class="insight-card">
    <h3 class="section-title">
      <span class="icon"><i class="mdi mdi-emoticon-outline"></i></span>
      Soft Skills
    </h3>
    <div class="attribute-list" v-if="softSkills && softSkills.length">
      <div
        v-for="(skill, index) in softSkills"
        :key="`soft-skill-${index}`"
        class="attribute-item"
      >
        <span class="attribute-icon"><i class="mdi mdi-check-circle"></i></span>
        <span class="attribute-text">{{ capitalize(skill) }}</span>
      </div>
    </div>
    <div v-else class="empty-state">
      <p>No soft skills found.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SoftSkills',
  props: {
    softSkills: {
      type: Object,
      required: true
    }
  },
  methods: {
    capitalize(string) {
      if (!string) return '';
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
};
</script>

<style lang="scss" scoped>
.insight-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  padding: 1.5rem 2rem;
  margin-bottom: 2rem;
  width: 100%;
}
.section-title {
  display: flex;
  align-items: center;
  color: $color-text;
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid $color-border-muted;
  .icon {
    margin-right: 12px;
    color: $color-primary;
    font-size: 1.4rem;
  }
}
.attribute-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 0.7rem;
  .attribute-item {
    display: flex;
    align-items: center;
    .attribute-icon {
      margin-right: 8px;
      font-size: 1.1rem;
      color: $color-primary;
    }
    .attribute-text {
      font-size: 1rem;
      color: $color-text-muted;
    }
  }
}
.empty-state {
  text-align: center;
  color: $color-text-subtle;
  font-size: 1rem;
  padding: 2rem 0;
}
</style>